import { useEffect, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useIsMobile } from 'hooks/useIsMobile';
import { BASE_ROUTE } from 'utilities/routes';
import { sanitize } from 'utilities/sanitizer';
import { useGetComponent } from 'hooks/useGetComponent';
import { componentIds } from 'utilities/constants';
import {
  Hasura_Legal_Document_Types_Enum,
  useGetLegalDocumentQuery,
} from 'graphql/generated/hasura';

export const LegalDocument = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const { data } = useGetComponent({
    componentId: componentIds.LEGAL_DOCS_TITLES,
    locale: 'en',
  });
  const { data: legalDocumentData } = useGetLegalDocumentQuery({
    variables: {
      type: id as Hasura_Legal_Document_Types_Enum,
    },
  });

  const legalDocument = useMemo(
    () => legalDocumentData?.getLegalDocument,
    [legalDocumentData],
  );

  useEffect(() => {
    if (legalDocument === null) {
      navigate(BASE_ROUTE);
    }
  }, [legalDocument, navigate]);

  if (legalDocument?.type) {
    return (
      <div className="flex-wrap px-2.5 desktop:px-[30px]">
        <h2 className="desktop:text-h1 text-h2 text-neutral-800 font-medium mb-30">
          {data?.[legalDocument?.type]}
        </h2>
        <div
          id="legalDocument"
          className="overflow-x-auto flex flex-col gap-5 overflow-y-auto"
          dangerouslySetInnerHTML={{
            __html: sanitize(
              isMobile ? legalDocument.contentMobile : legalDocument.contentWeb,
            ),
          }}
        />
      </div>
    );
  }

  return null;
};
